import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import { Grid, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";

import { AppleMap, ZipCodeSearchForm, PanelContainer, Heading, Body } from "@/basic/components";
import { FormularyParams } from "@/basic/components/FormularyButtonContainer";

export const PharmacyJourneyZipContainer = () => {
  const { t: translate } = useTranslation();
  const { formulary }: FormularyParams = useParams();

  const center = {
    latitude: 39.553786,
    longitude: -95.13472,
  };

  const { mapContainerColumn, zipCodeContainer } = useResponsive(
    useMemo(
      () => ({
        zipCodeContainer: { desktop: 4, tablet: 4, mobile: 12 },
        mapContainerColumn: { desktop: 8, tablet: 8, mobile: 12 },
      }),
      [],
    ),
  );

  return (
    <PanelContainer>
      <Grid>
        <Grid.Span columns={zipCodeContainer}>
          <>
            <Stack>
              <Heading>{translate("PHARMACY_JOURNEY_ZIP_CONTAINER.findLocalPharmacy")}</Heading>
              <ZipCodeSearchForm pushTo={`/${formulary}/pharmacy/list`} />
            </Stack>
            <Body>{translate("PHARMACY_JOURNEY_ZIP_CONTAINER.enterZipCode")} </Body>
          </>
        </Grid.Span>

        <Grid.Span columns={mapContainerColumn}>
          <AppleMap center={center} />
        </Grid.Span>
      </Grid>
    </PanelContainer>
  );
};
